export default {
    investorTrx: [],
    supplierTrx: [],
    applicantTrx: [],
    rgTrx: [],
    modules: {
        investor: 0,
        supplier: 0,
        applicant: 0,
        rg: 0,
        financialAdvisor: 0,
    },
    processors: {
        openpay: {
            required: 0,
            inAccount: 0
        },
        stp: {
            required: 0,
            inAccount: 0
        },
    }
}
